<template>
  <div class="flex-none">
    <h1 class="text-gray-800 text-center text-5xl font-bold font-serif my-8">
      About Us
    </h1>
    <div class="w-5/6 lg:flex mx-auto m-5 my-10 lg:my-0 shadow-2xl">
      <div
        class="h-96 w-full lg:h-auto lg:w-1/3 flex-none bg-cover rounded-t lg:rounded-t-none lg:rounded-l text-center overflow-hidden bg-center"
        style="background-image: url('../../img/black_bg_logo.13ef7954.png')"
      ></div>
      <div
        class="border-r border-b border-l border-grey-light lg:border-l-0 lg:border-t lg:border-grey-light bg-gray-50 rounded-b lg:rounded-b-none lg:rounded-r p-8 flex flex-col justify-between leading-normal"
      >
        <div class="mb-8">
          <div class="text-black text-3xl mb-4">Who are we?</div>
          <p class="text-grey-darker font-light">
            We at Fashion.o.Phile are obsessed with all things stylish! We
            define fashion with every garment, accessory and knick-knack that we
            conjure.
            <br /><br />
            You have the sass, we have the spunk! While we create and curate our
            own designs with our brilliant minded designers, we’re always open
            to pandering to your quirky ideas… Feel free to reach out to us for
            translating ideas in your head into real designs. Together we can
            make it happen.
            <br /><br />
            Designer clothes, eye-catching masks, accessories with your initials
            or your name, mix-and-match brooches, bespoke evil-eye clutches,
            embroidered purses… anything and everything that will make your
            style quotient soar!
          </p>
        </div>
        <div class="text-4xl flex flex-row items-center">
          <div class="text-black text-2xl inline-block">Follow Us:</div>
          <a
            class="px-4 md:px-8 hover:scale-110 transform duration-200 hover:text-gray-300"
            href="https://instagram.com/fashion.o.phile"
            target="_blank"
          >
            <i class="fab fa-instagram"></i>
          </a>
          <a
            class="hover:scale-110 transform duration-200 hover:text-gray-300"
            href="mailto:fashnophl@gmail.com"
          >
            <i class="fas fa-envelope"></i>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
